<div class="tix-card-header-text">
  <ng-content
    select="tix-card-title, tix-card-subtitle,
      [tix-card-title], [tix-card-subtitle],
      [tixCardTitle], [tixCardSubtitle]"
  ></ng-content>
</div>
<ng-content></ng-content>
